/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const SemanticAuditorCreateTestDialogErrorTypes = {
  DUPLICATE_NAME: 'DUPLICATE_NAME',
  EMPTY_NAME: 'EMPTY_NAME',
  REQUEST_ERROR: 'REQUEST_ERROR',
} as const;

export type SemanticAuditorTestDialogErrors = keyof typeof SemanticAuditorCreateTestDialogErrorTypes;
